import React from 'react';

import { Button } from 'components/ui/button';
import { Spinner } from 'components/ui/spinner';
import { getTestId } from 'utils/testUtils';

interface SubmitButtonProps {
  onSubmit: () => void | Promise<void>;
  isDisabled: boolean;
  isLoading: boolean;
  buttonText?: string;
  isAlreadySubmitted?: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  onSubmit,
  isDisabled,
  isLoading,
  buttonText = 'Submit',
  isAlreadySubmitted = false,
}) => {
  const showSubmittedState = isAlreadySubmitted && buttonText !== 'Continue';
  const handleClick = () => {
    void onSubmit();
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={isDisabled || isLoading || showSubmittedState}
      variant='secondary'
      size='auto'
      {...getTestId('submit-button')}
    >
      {isLoading ? <Spinner size="sm" /> : showSubmittedState ? 'Submitted' : buttonText}
    </Button>
  );
};
